// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datatable-postportfolio-dash .p-paginator .p-paginator-current {
  margin-left: auto;
}

.datatable-postportfolio-dash .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
}

.datatable-postportfolio-dash .p-progressbar .p-progressbar-value {
  background-color: #607d8b;
}

.datatable-postportfolio-dash .table-header {
  display: flex;
  justify-content: space-between;
}

.datatable-postportfolio-dash .table-header .heading {
  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.datatable-postportfolio-dash .p-datepicker {
  min-width: 25rem;
}

.datatable-postportfolio-dash .p-datepicker td {
  font-weight: 400;
}

.datatable-postportfolio-dash .p-datatable.p-datatable-header {
  padding: 1rem;
  text-align: left;
  font-size: 2rem;
}

.datatable-postportfolio-dash .p-datatable.p-paginator {
  padding: 1rem;
}

.datatable-postportfolio-dash .p-datatable.p-datatable-thead > tr > th {
  text-align: left;
}

.datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr > td {
  cursor: auto;
}

.datatable-postportfolio-dash
  .p-datatable.p-dropdown-label:not(.p-placeholder) {
  text-transform: uppercase;
}

.datatable-postportfolio-dash .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.datatable-postportfolio-dash .narrow-column {
  width: 200px !important;
}
.datatable-postportfolio-dash .p-inputtext {
  font-size: 0.8rem;
}

.datatable-postportfolio-dash .p-multiselect {
  font-size: smaller;
}

.datatable-postportfolio-dash .p-multiselect-item {
  font-size: smaller;
}

.datatable-postportfolio-dash .p-button {
  font-size: smaller;
}

.datatable-postportfolio-dash .table-status-active {
  background-color: #a9dfbf;
  color: #495057;
  font-weight: normal;
  min-width: 5rem;
}

.datatable-postportfolio-dash .table-status-inactive {
  background-color: #f2f4f4;
  color: #495057;
  font-weight: normal;
  min-width: 5rem;
}

.datatable-postportfolio-dash .table-date-due {
  background-color: #ffecb3;
  color: #495057;
  font-weight: normal;
}

.datatable-postportfolio-dash .table-date-ok {
  background-color: #ffffff;
  color: #495057;
  font-weight: normal;
}

.datatable-postportfolio-dash .table-stage-IND {
  background-color: #53a9a8;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}

.datatable-postportfolio-dash .table-stage-P1 {
  background-color: #344e41;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
}

.datatable-postportfolio-dash
  .p-datatable-wrapper
  > table
  > thead
  > tr:nth-child(2)
  > th:nth-child(5)
  > div
  > div
  > div
  > div:nth-child(2)
  > span {
  margin-right: 2.5rem;
}

@media screen and (max-width: 960px) {
  .datatable-postportfolio-dash .p-datatable.p-datatable-thead > tr > th,
  .datatable-postportfolio-dash .p-datatable.p-datatable-tfoot > tr > td {
    display: none !important;
  }

  .datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr {
    border-bottom: 1px solid var(--layer-2);
  }

  .datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr > td {
    text-align: left;
    display: block;
    border: 0 none !important;
    width: 100% !important;
    float: left;
    clear: left;
    border: 0 none;
  }

  .datatable-postportfolio-dash
    .p-datatable.p-datatable-tbody
    > tr
    > td
    .p-column-title {
    padding: 0.4rem;
    min-width: 30%;
    display: inline-block;
    margin: -0.4rem 1rem -0.4rem -0.4rem;
    font-weight: bold;
  }

  .datatable-postportfolio-dash
    .p-datatable.p-datatable-tbody
    > tr
    > td
    .p-progressbar {
    margin-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scene-d/PostPortfolio/PostPortfolioDash/PostPortfolioDash.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;;;;;EAWE,oBAAoB;AACtB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,cAAc;EAChB;;EAEA;;;;;IAKE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;;;;;IAKE,kBAAkB;EACpB;AACF","sourcesContent":[".datatable-postportfolio-dash .p-paginator .p-paginator-current {\n  margin-left: auto;\n}\n\n.datatable-postportfolio-dash .p-progressbar {\n  height: 0.5rem;\n  background-color: #d8dadc;\n}\n\n.datatable-postportfolio-dash .p-progressbar .p-progressbar-value {\n  background-color: #607d8b;\n}\n\n.datatable-postportfolio-dash .table-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.datatable-postportfolio-dash .table-header .heading {\n  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.datatable-postportfolio-dash .p-datepicker {\n  min-width: 25rem;\n}\n\n.datatable-postportfolio-dash .p-datepicker td {\n  font-weight: 400;\n}\n\n.datatable-postportfolio-dash .p-datatable.p-datatable-header {\n  padding: 1rem;\n  text-align: left;\n  font-size: 2rem;\n}\n\n.datatable-postportfolio-dash .p-datatable.p-paginator {\n  padding: 1rem;\n}\n\n.datatable-postportfolio-dash .p-datatable.p-datatable-thead > tr > th {\n  text-align: left;\n}\n\n.datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr > td {\n  cursor: auto;\n}\n\n.datatable-postportfolio-dash\n  .p-datatable.p-dropdown-label:not(.p-placeholder) {\n  text-transform: uppercase;\n}\n\n.datatable-postportfolio-dash .p-datatable-tbody > tr > td .p-column-title {\n  display: none;\n}\n\n.datatable-postportfolio-dash .narrow-column {\n  width: 200px !important;\n}\n.datatable-postportfolio-dash .p-inputtext {\n  font-size: 0.8rem;\n}\n\n.datatable-postportfolio-dash .p-multiselect {\n  font-size: smaller;\n}\n\n.datatable-postportfolio-dash .p-multiselect-item {\n  font-size: smaller;\n}\n\n.datatable-postportfolio-dash .p-button {\n  font-size: smaller;\n}\n\n.datatable-postportfolio-dash .table-status-active {\n  background-color: #a9dfbf;\n  color: #495057;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.datatable-postportfolio-dash .table-status-inactive {\n  background-color: #f2f4f4;\n  color: #495057;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.datatable-postportfolio-dash .table-date-due {\n  background-color: #ffecb3;\n  color: #495057;\n  font-weight: normal;\n}\n\n.datatable-postportfolio-dash .table-date-ok {\n  background-color: #ffffff;\n  color: #495057;\n  font-weight: normal;\n}\n\n.datatable-postportfolio-dash .table-stage-IND {\n  background-color: #53a9a8;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.datatable-postportfolio-dash .table-stage-P1 {\n  background-color: #344e41;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n}\n\n.datatable-postportfolio-dash\n  .p-datatable-wrapper\n  > table\n  > thead\n  > tr:nth-child(2)\n  > th:nth-child(5)\n  > div\n  > div\n  > div\n  > div:nth-child(2)\n  > span {\n  margin-right: 2.5rem;\n}\n\n@media screen and (max-width: 960px) {\n  .datatable-postportfolio-dash .p-datatable.p-datatable-thead > tr > th,\n  .datatable-postportfolio-dash .p-datatable.p-datatable-tfoot > tr > td {\n    display: none !important;\n  }\n\n  .datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr {\n    border-bottom: 1px solid var(--layer-2);\n  }\n\n  .datatable-postportfolio-dash .p-datatable.p-datatable-tbody > tr > td {\n    text-align: left;\n    display: block;\n    border: 0 none !important;\n    width: 100% !important;\n    float: left;\n    clear: left;\n    border: 0 none;\n  }\n\n  .datatable-postportfolio-dash\n    .p-datatable.p-datatable-tbody\n    > tr\n    > td\n    .p-column-title {\n    padding: 0.4rem;\n    min-width: 30%;\n    display: inline-block;\n    margin: -0.4rem 1rem -0.4rem -0.4rem;\n    font-weight: bold;\n  }\n\n  .datatable-postportfolio-dash\n    .p-datatable.p-datatable-tbody\n    > tr\n    > td\n    .p-progressbar {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
